<template>
  <v-dialog
      :value="cambia"
      persistent
  >

          <v-row align="center" justify="center" class="text-center">
            <v-col cols="12" sm="12" md="8" lg="8">
             <v-card>
               <v-card-title>
               <v-row align="center" class="text-center">
                 <v-col cols="12" sm="12" md="12" lg="12">
                    Elige la fiesta y mira como te fue con tus invitados
                 </v-col>
               </v-row>
             </v-card-title>
               <v-card-text>
                <v-row>
                  <v-col  cols="12" sm="12" md="12">
                    <v-autocomplete  v-model="fiestaId" :items="fiestas"  item-value="uniqueId" item-text="nombre"  persistent-hint
                                        @change="dameListas"
                                     single-line label="Escoger Fiesta"></v-autocomplete>
                  </v-col>

                </v-row>


                <v-row>
                  <v-col>
                  <v-data-table
                      :headers="headers"
                      :items="listas"
                      no-data-text="No hay datos disponibles para mostrar."
                      no-results-text="No hay resultados para la búsqueda."
                      loading-text="Cargando... Por favor espere."
                      :header-props="headerProps"
                      :footer-props="footerProps"

                  >
                  </v-data-table>
                  </v-col>
                </v-row>

               </v-card-text>
               <v-card-actions>
                 <v-row>

                   <v-col>
                     <v-btn text  @click="$emit('cierra')">Cerrar</v-btn>
                   </v-col>
                 </v-row>
               </v-card-actions>
             </v-card>
            </v-col>
          </v-row>

        <v-overlay :value="overlay">
          <v-img
              src="@/assets/loadtunay.gif"

          />
        </v-overlay>
  </v-dialog>

</template>

<script>
import axios from 'axios';
export default {
  name: "reportelista",
  components: {
  },
  metaInfo() {
    return {
      title: this.titulonegocio,
        meta: [
      {property: "og:image", content: this.logoimg},
      {property: "og:image:width", content: "699"},
      {property: "og:image:height", content: "366"},
      {
        property: "og:description",
        content: "Lista de  "+this.titulonegocio
      }
    ]
    }
  },
  props:{
    promotor:{
      "id":1,
      "promotorNombre":"Nombre",
      "hashPromotor":""
    },
    cambia: Boolean
  },
  data () {
    return{
      md5promo: '',
      overlay:false,
      alertnuevo:false,
      logoexist: false,
      logoimg: null,
      fiestas:[],
      headerProps: {
        sortByText: "Ordenar por"
      },
      footerProps: {
        itemsPerPageText: "Items por página"
      },
      rese:'',
      browser:false,
      activopr: true,
      progr:false,
      mostrarlista:true,
      alertatipolista:false,
      botn: false,
      mobile:false,
      nombres:'',
      logo270:'',
      fiestaId:'',
      tipoListaId:0,
      url:'',
      search: '',

      shtitle:'',
      shdescr:'',
      shquote:'',
      editedIndex: -1,
      emailRules: [
        v => !!v || 'E-mail es requerido',
        v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido',
      ],
      titulonegocio:'',
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      headers: [
        { text: 'Nombre', value: 'nombre' },
        { text: 'Tipo de Lista', value: 'tipoLista'},

        { text: 'Fecha de Ingreso', value: 'fechaIngreso'},

      ],
      negocitag: '',
      qrs:[],
      cantidad:0,
      cantmax:{
        cantidadmaxima: 'Elija Fiesta y Tipo de Lista para obtener la cantidad',
        cantidadactual:'',
        posibles:''
      },
      maximo: 0,
      promotorId:0,
      txtcopia:'',
      dialogdelete: false,

      listas:[],
      styleColorLetra:{
        color: 'black'
      },
      Cardcolor:'black',
      stylePagina: {
        backgroundColor: 'black',
        color:'white',
        backgroundImage:'',
        backgroundSize: 'cover',
        height:"100%"

      },
      lista:{},
      editedItem: {
        id:0,
        listaFiesta:{
          id:0,
          titular:'',
          promotor:{},
          tipoLista:{},
          fiesta:{},
          createdAt: '2020-01-01 00:00:00'
        },
        nombre:'',
        codigoUnico:'',
        personaId:0,
        fechaIngreso:null,
        f:false,
        createdAt: '2020-01-01 00:00:00'
      },

    }
  }
  ,
  mounted (){
    let cantEs = document.documentElement.clientWidth;

    if(cantEs<=450){
      this.mobile = true
    }
      this.dameFiestas()
  }
,
  watch: {
    cambia(){
      if (this.cambia){
        this.dameFiestas()
      }
    }
  },

  methods: {

    close () {
      this.dialog = false;
      this.dialogdelete = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    dameListas(){
      if(this.promotor.hashPromotor !== undefined){
      let urlfiesta = 'lista/fiesta/promotor/hash';
      this.overlay = true
      var bodyFormData = new FormData();
      bodyFormData.append("fId",this.promotor.hashPromotor);

      bodyFormData.append("nTg",this.fiestaId);
      axios
          .post(urlfiesta,bodyFormData)
          .then(response => {
            this.listas = response.data;
            this.overlay = false;
          })
          .catch((error)  => {
            console.error(error);
            this.overlay = false;
          });
      }
    },

    dameFiestas(){
      let urlfiesta = 'actos/fiestas/promotor/'+this.promotor.hashPromotor;
      if(this.promotor.hashPromotor !== undefined){
        this.overlay = true

        axios
            .get(urlfiesta)
            .then(response => {
              this.fiestas = response.data;
              this.fiestaId = this.fiestas[0].uniqueId
              this.dameListas()
              this.overlay = false;
            })
            .catch((error)  => {
              console.error(error);
              this.overlay = false;
            });

      }
    }

  }
}
</script>

<style scoped>

</style>
